import { navigateTo } from "./navigate-to/navigateTo";

export const navigate = (urlOrPath?: string): void => {
  if (urlOrPath) {
    navigateTo(urlOrPath);
  } else {
    window.location.reload();
  }
};
